<template>
      <div id="overlay" v-if="multipleprofile_switch_flg">
        <div id="message_area" style="height:70%;width:95%;max-width: 600px;background-color: white;">
          <div>
            <h2 class="kojin-title">ユーザー切替</h2>
            <button class="btn btn-primary" style="margin: auto;background-color: #F5F5F5;color:#000;border:1px solid #000;" 
            v-if="GlobalData.$user_end == 0"
            v-on:click="openAdd()">＋ ユーザーを追加</button>
          </div>
          切り替えたいユーザ名をクリックしてください。
          <div style="width:85%; margin:auto; margin-top:3%;min-height: 0px;height: 70%">
            <table style="width:100%; border-collapse: collapse;border: #ccc solid 1px;">
              <thead>
                <tr>
                  <th class="type-col">ユーザーID</th>
                  <th style="background-color: pink;width: 80%;">ユーザー名</th>
                  <th class="type-col">種類</th>
                  <th style="background-color: pink;width: 20%;"></th>
                </tr>
              </thead>
            </table>

            <div style="overflow-x: hidden;overflow-y: auto;height: 60%;border: #ccc solid 1px;">
              <table style="width:100%; border-collapse: collapse;">
                <tbody>
                  <tr v-for="(result,i) in multipleusers.value.slice(0,multipleusers.value.length)" v-bind:key="i" tabindex="0">
                    <td class="type-col">
                      {{ result.taikenuser_id }}
                    </td>
                    <td :class="{ 'highlight-row': result.taikenuser_id == user_id.value }"
                        v-on:click="User_Switch(result.taikenuser_id, result.role)" style="width: 80%;cursor:pointer;">
                          {{ result.username }}
                    </td>
                    <td class="type-col">
                      {{ result.role }}
                    </td>
                    <td :class="{ 'highlight-row': result.taikenuser_id == user_id.value }" style="width: 20%;">
                      <p v-if="result.role == false" style="margin:0;">  
                        <button class="btn btn-primary mx-aut" style="width: 100%;padding: 0;background-color: #F5F5F5;color:#000;border:1px solid #000"
                            v-on:click="multipleUser_delete_check(result.taikenuser_id, result.username, result.role)">削除</button>   
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div style="margin-top:2%;">
              <button class="btn btn-primary mx-aut" style="width: 200px; height: 50px;margin: 10px 0px 0px 0px;background-color: blue;color:white;clear: right;"
              v-on:click="multipleprofile_switch_close()">キャンセル</button>
            </div>
          </div>
        </div>
      </div>

      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>

</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { GlobalData } from '../js/userdata.js';
/* メッセージを表示するモーダルウィンドウ */
import MessageModal from '../common/MessageModal.vue'  
import { useRouter, useRoute } from 'vue-router'

const router = useRouter();
let route = useRoute()

const cityname = route.params.shakyo

let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ

/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント

const props = defineProps(["multipleprofile_switch_flg" , "param_multiple" , "user_id" ]);

let multipleprofile_switch_flg = ref(false);
let multipleusers = ref(null);
let user_id = ref(null);

multipleprofile_switch_flg.value = ref(props.multipleprofile_switch_flg);
multipleusers.value = ref(props.param_multiple.multipleusers);
user_id.value = ref(props.user_id);

let tagetUser_id = null
let tagetRole = null

const emit = defineEmits(['call' , 'multipleprofile_close']);

const User_Switch = (u_id, role) =>{
    // 複数ユーザーを切り替える
    emit('call', { cmd:'switch_user', id:u_id, role:role });
}

const multipleprofile_switch_close = () => {  //このウィンドウを閉じる
    multipleprofile_switch_flg = false;
    emit('multipleprofile_close',multipleprofile_switch_flg);
}


const multipleUser_delete_check = (u_id, username, role) => {
    tagetUser_id = u_id
    tagetRole = role
    // 複数ユーザーのユーザーを削除する
    if(role == true){
        message.value = "アカウントを削除しますか？\n※削除後、復旧はできません。";
        message_cat.value = 1;
        message_flag.value = true;
        message_method.value = "multipleUser_delete_check";
        contentMessage.value = MessageModal
        return
    } else if(u_id == GlobalData.user_id){
        message.value = "自分自身を削除することになりますが削除しますか？";
        message_cat.value = 1;
        message_flag.value = true;
        message_method.value = "multipleUser_delete_check";
        contentMessage.value = MessageModal
        return
    }

    message.value = "「"+username+"」様を削除しますか？";
    message_cat.value = 1;
    message_flag.value = true;
    message_method.value = "multipleUser_delete_check";
    contentMessage.value = MessageModal

}

// 体験プログラムキャンセル時、同時にキャンセルする事前説明会を抽出する（廃止）
// メッセージを表示するウィンドウでOKを押された時
const OK_message = function(){ 
    Close_message();//メッセージを表示するウィンドウを閉じる

    if(message_method.value == "multipleUser_delete_check"){
      // アカウントを削除しますか？
      multipleUser_delete()
    }
}

// メッセージを表示するウィンドウを閉じる
const Close_message = function(){
    message_flag.value = false;
    contentMessage.value = null
}

const multipleUser_delete = () => {
    // 複数ユーザーのユーザーを削除する
    emit('call', { cmd:'multipleUser_delete', id:tagetUser_id, role:tagetRole});
    multipleprofile_switch_close();
}

const openAdd = () => {
    router.push('/'+cityname+'/Taiken/multipleprofile');
    multipleprofile_switch_close();
}

</script>
<style>
#overlay{
  /* 要素を重ねた時の順番 */
  z-index:1;

  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);

  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 種類列は要求通り display:none で非表示、ただしDOMには残す */
.type-col {
  display:none;
}

.t-block {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.highlight-row {
  background-color: #d6ffff; /* 条件一致時の色 */
}

</style>

